import { render, staticRenderFns } from "./distributionStation-list.vue?vue&type=template&id=3020d2fe&scoped=true"
import script from "./distributionStation-list.vue?vue&type=script&lang=js"
export * from "./distributionStation-list.vue?vue&type=script&lang=js"
import style0 from "./distributionStation-list.vue?vue&type=style&index=0&id=3020d2fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020d2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3020d2fe')) {
      api.createRecord('3020d2fe', component.options)
    } else {
      api.reload('3020d2fe', component.options)
    }
    module.hot.accept("./distributionStation-list.vue?vue&type=template&id=3020d2fe&scoped=true", function () {
      api.rerender('3020d2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/distributionStation-management/distributionStation-list/distributionStation-list.vue"
export default component.exports